import axios from 'axios'
import store from '@/store/store.js'
import empty from 'is-empty'
import VueCookies from 'vue-cookies'
export function getTeryInfo (key) {
  console.log('3::::')
  axios({
    method: 'get',
    url: `${process.env.API}/getTeryInfo/key/${key}`
  })
    .then((response) => {
      if (!empty(response)) {
        store.state.userData = response.data[0]
        var userData = JSON.stringify(response.data[0])
        VueCookies.set('userData', userData, '30min')
        VueCookies.set('userSeq', userData.USER_SEQ)
        setTimeout(() => {
          store.state.isLoading = false
          window.location.reload()
        }, 200)
      } else {
        console.log('getTeryInfo err')
      }
    })
}
export function loginWithKakao () {
  console.log('1::::')
  window.Kakao.Auth.loginForm({
    success: (authObj) => {
      console.log('authObj:::', authObj)
      getUserInfo()
    },
    fail: (err) => {
      console.log(JSON.stringify(err))
    }
  })
}
export function getUserInfo () {
  console.log('2::::')
  window.Kakao.API.request({
    url: '/v2/user/me',
    success: (response) => {
      var login = JSON.stringify(response)
      console.log('login:::', login)
      VueCookies.set('kakaoLogin', login, '30min')
      getTeryInfo(response.id)
    },
    fail: (error) => {
      console.log('fail:::', error)
    }
  })
}
export function logout () {
  if (!window.Kakao.Auth.getAccessToken()) {
    console.log('사용자없음11111')
    store.state.userData = {}
    VueCookies.remove('kakaoLogin')
  } else {
    window.Kakao.Auth.logout(() => {
      store.state.userData = {}
      VueCookies.remove('kakaoLogin')
      // this.$store.state.isLoading = false
      alert('로그아웃 되었습니다.')
      window.location.reload()
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/publicFunc/public.js